<template>
  <div>    
    <v-card outlined elevation="12">
      <v-toolbar dense color="#FC8333" dark>
        <v-toolbar-title>Reclamos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-divider class="mx-4" vertical />
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                @click="fillCbxShowModal()"
                x-large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-database-plus</v-icon>
              </v-btn>
            </template>
            <span>Crear Nuevo</span>
          </v-tooltip>
          <v-divider class="mx-4" vertical />
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          :headers="headersR"
          :items="reclamosTbl"
          class="elevation-1"
        >
          <template v-slot:item.acciones="{ item }">
              <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="info"
                  @click="fillCbxShowModal(true, item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="red"
                  @click="deleteReclamo(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>
          <template v-slot:item.se_indemnizo="{ item }">
              <v-icon v-if="item.se_indemnizo" color="green">mdi-check</v-icon>
              <v-icon v-else color="red">mdi-close</v-icon>
            </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <!--FORMULARIO MODAL -->
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      persistent
      width="800"
    >
      <v-card elevation="24" outlined>
        <v-toolbar dark dense color="#96298A">
          <v-toolbar-title>Reclamo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-divider vertical />
            <v-btn icon dark @click="closeAndResetCbx()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-divider vertical />
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="camposBD.fecha_admision"
                  label="Fecha Admisión Reclamo"
                  type="date"                  
                  clearable
                  onkeydown="return false"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="camposBD.fecha_ocurrencia"
                  label="Fecha Ocurrencia"
                  type="date"                  
                  clearable
                  onkeydown="return false"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="camposBD.fecha_admision_envio"
                  label="Fecha Admisión Envío"
                  type="date"                  
                  clearable
                  onkeydown="return false"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="8" md="8">
                    <v-combobox
                        v-model="causal"
                        :items="causales"
                        item-text="causal"
                        item-value="id"
                        label="Causal"                        
                        required
                        clearable
                        append-icon="mdi-shield-alert"
                        return-object                        
                        ></v-combobox>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-combobox
                        v-model="estado"
                        :items="estados"
                        item-text="estado"
                        item-value="id"
                        label="Estado"                        
                        required
                        clearable
                        append-icon="mdi-alert-circle"
                        return-object                        
                        ></v-combobox>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="4" md="4">
                    <v-text-field
                        v-model="camposBD.fecha_finalizacion"
                        label="Fecha Finalizacíon"
                        type="date"                  
                        clearable
                        onkeydown="return false"
                        ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" md="6">
                    <v-checkbox 
                    v-model="camposBD.se_indemnizo"
                    label="Se indemnizo"
                    ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field
                    v-model="camposBD.valor_indemnizacion"
                    label="Valor Indemnización"
                    type="number"
                    append-icon="mdi-cash"
                    v-if="camposBD.se_indemnizo"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-textarea
                    v-model="camposBD.acuerdo_pactado"
                    label="Acuerdo Pactado"
                    append-icon="mdi-handshake"
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-text-field
                    v-model="camposBD.resena"
                    label="Reseña"
                    append-icon="mdi-alarm-light-outline"
                    ></v-text-field>
                </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" outlined @click="closeAndResetCbx()">
            Cancelar
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
          <v-btn color="primary darken-1" outlined @click="saveItem()">
            Guardar
            <v-icon dark>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from "./Waiting.vue";
import apicon from "../plugins/apicon";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Waiting,
  },
  created: function () {},
  watch:{
      causal: function(item){
          if(item){
              this.camposBD.id_causal = item.id;
          }
      },
      estado: function(item){
          if(item){
              this.camposBD.id_estado = item.id;
          }
      }
  },
  data() {
    return {
      dialog: false,
      valid: true,
      modalEditando: false,
      headersR: [
        { text: "Fecha Admisión Reclamo", value: "fecha_admision" },
        { text: "Fecha Ocurrencia", value: "fecha_ocurrencia" },
        { text: "Fecha Admisión Envio", value: "fecha_admision_envio" },
        { text: "Causal", value: "causal.causal" },
        { text: "Estado", value: "estado.estado" },
        { text: "Fecha Finalización", value: "fecha_finalizacion" },
        { text: "Se Indemnizo", value: "se_indemnizo" },
        { text: "Valor Indemnización", value: "valor_indemnizacion" },
        { text: "Acuerdo Pactado", value: "acuerdo_pactado" },
        { text: "Reseña", value: "reseña" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      reclamosTbl: [],
      overlay: false,
      causales: [],
      causal: null,
      estados: [],
      estado: null,
      /*Variables*/
      camposBD: {
        id: 0,
        id_guia: null,
        fecha_admision: null,
        fecha_ocurrencia: null,
        fecha_admision_envio: null,
        causal: null,
        estado: null,
        fecha_finalizacion: null,
        se_indemnizo: false,
        valor_indemnizacion: null,
        acuerdo_pactado: null,
        resena: null,
      },
      /*Variables*/ 
    };
  },
  methods: {
    fillReclamosGuia: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "reclamobyguia/" + this.id)
        .then((result) => {
          this.reclamosTbl = result;
        });
    },
     //Guardar o Actualizar
    saveItem: function () {
        this.camposBD.id_guia = this.id;
      if (this.$refs.form.validate()) {
        //Actualizar
        if (this.modalEditando) {
          apicon.updateDataApi(
            apicon.getApiBaseUrl() + "reclamo/" + this.camposBD.id,
            this.camposBD
          ).then((result) => {
            this.fillReclamosGuia();
            this.closeAndResetCbx();
            this.$swal(result.message);
          });
        } else {
          //Guardar
          apicon
            .saveDataApi(apicon.getApiBaseUrl() + "reclamo", this.camposBD)
            .then((result) => {
              this.fillReclamosGuia();
              this.limpiarCampos();                            
              this.$swal(result.message);
            });
        }
      }
    },
    fillCbxShowModal: async function (editando = false, item = []) {
      this.modalEditando = editando;

      if (editando) {
        await Object.keys(this.camposBD).forEach((key) => {
          this.camposBD[key] = item[key];
        });
        this.causal = item.causal;
        this.estado = item.estado;
      } else {
        this.limpiarCampos();
      }
      this.dialog = true;
    },
    limpiarCampos: function () {
      Object.keys(this.camposBD).forEach((key) => {
        this.camposBD[key] = null;
      });
      this.estado = null;
      this.causal = null;
      this.camposBD.se_indemnizo = false; //default
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    closeAndResetCbx: function () {
      this.limpiarCampos();
      this.dialog = false;
    },
    deleteReclamo: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          apicon
            .deleteDataApi(apicon.getApiBaseUrl() + "reclamo/" + item.id)
            .then(async (result) => {
              await self.fillReclamosGuia();
              this.$swal(result.message);
            });
        }
      });
    },
    getCausales: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'reclamocausales').then((result) => {
            this.causales = result;
        });
    },
    getEstados: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'reclamoestados').then((result) => {
            this.estados = result;
        });
    },
  },
  mounted: async function () {
    apicon.setAuthHeaders();
    await this.fillReclamosGuia();
    this.getCausales();
    this.getEstados();
  },
};
</script>